module.exports = window["MaterialUI"].ListItemSecondaryAction;